export const LogoImage = ({ className = "h-12 w-auto" }) => (
  <img
    src="/she-global-logo.png"
    alt="SHE Global™ Institute — Supporting Her Evolution™"
    className={className}
    data-testid="she-logo"
  />
);
